import { render, staticRenderFns } from "./BaseIconSelect.vue?vue&type=template&id=b8ad4e96&scoped=true&lang=html&"
import script from "./BaseIconSelect.vue?vue&type=script&lang=js&"
export * from "./BaseIconSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconSelect.vue?vue&type=style&index=0&id=b8ad4e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad4e96",
  null
  
)

export default component.exports